var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightboxDownload = function SvgLightboxDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.012 9.53a.988.988 0 0 1 1.36 0l3.167 3.05V.925c0-.511.43-.926.961-.926.531 0 .961.415.961.926v11.653l3.167-3.049a.988.988 0 0 1 1.36 0 .902.902 0 0 1 0 1.31l-4.808 4.63a.988.988 0 0 1-1.36 0l-4.808-4.63a.902.902 0 0 1 0-1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.962 12.963c.53 0 .961.415.961.926v4.63c0 1.022.861 1.851 1.923 1.851h17.308c1.062 0 1.923-.829 1.923-1.852v-4.63c0-.51.43-.925.961-.925.532 0 .962.415.962.926v4.63c0 2.045-1.722 3.703-3.846 3.703H3.846C1.722 22.222 0 20.564 0 18.518v-4.63c0-.51.43-.925.962-.925Z"
  }))));
};
export default SvgLightboxDownload;